import type { z } from 'zod'

/**
 * Zod 3's `required_error` / `invalid_type_error` for a Zod 4 schema: a missing value gets `required`, any other value
 * of the wrong type gets `invalidType`, and every other issue keeps its own message.
 *
 * `z.number(typeErrors({ required: 'Notice Period is required', invalidType: 'Notice Period must be a number' }))`
 */
export function typeErrors({ required, invalidType }: { required?: string; invalidType?: string }) {
    return {
        error: (issue: z.core.$ZodRawIssue) => {
            if (issue.input === undefined) return required
            return issue.code === 'invalid_type' ? invalidType : undefined
        },
    }
}
